export function getCachedPrice(coin) {
  const cachedData = localStorage.getItem(coin);

  if (!cachedData) return null;

  const { value, expiry } = JSON.parse(cachedData);
  const isCacheValid = Date.now() < expiry

  return isCacheValid ? value : null;
}

export function setCachedPrice(coin, value) {
  const minuteInMilliseconds = 60000;
  const expiry = Date.now() + minuteInMilliseconds;
  localStorage.setItem(coin, JSON.stringify({ value, expiry }));
}